import React from 'react';

export interface IItemResumo {
  label: string;
  valor?: string;
}

interface IResumoReservaProps {
  titulo?: string;
  itens: IItemResumo[];
  destaque?: IItemResumo;
}

export default function ResumoReserva({ titulo = 'Resumo', itens, destaque }: IResumoReservaProps) {
  return (
    <div>
      <h3 className='mb-3 text-xs font-semibold uppercase tracking-wider text-zinc-500'>{titulo}</h3>
      <dl className='space-y-2 text-sm'>
        {itens.map(item => (
          <div key={item.label} className='flex items-start justify-between gap-4'>
            <dt className='text-zinc-500'>{item.label}</dt>
            <dd className={`text-right font-medium ${item.valor ? 'text-zinc-900' : 'text-zinc-300'}`}>
              {item.valor || '—'}
            </dd>
          </div>
        ))}
      </dl>
      {destaque && (
        <div className='mt-4 flex items-baseline justify-between border-t border-zinc-100 pt-4'>
          <span className='text-sm text-zinc-500'>{destaque.label}</span>
          <span className={`text-2xl font-semibold ${destaque.valor ? 'text-zinc-900' : 'text-zinc-300'}`}>
            {destaque.valor || '—'}
          </span>
        </div>
      )}
    </div>
  );
}
